import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { ArrowIonicLeftIcon as m } from "../../../icons/arrow-ionic-left-icon.mjs";
import { ArrowIonicRightIcon as s } from "../../../icons/arrow-ionic-right-icon.mjs";
import { twMerge as o } from "tailwind-merge";
const y = ({
  date: t,
  prevMonthButtonDisabled: e,
  nextMonthButtonDisabled: i,
  increaseMonth: l,
  decreaseMonth: a,
  intlLocale: n
}) => /* @__PURE__ */ c("div", { className: "flex items-center justify-between px-2 py-2", children: [
  /* @__PURE__ */ r(
    "button",
    {
      onClick: a,
      disabled: e,
      type: "button",
      className: o(
        "group rounded-full outline-hidden  ",
        e && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ r(m, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  ),
  /* @__PURE__ */ r("span", { className: "text-text-primary text-base", children: new Intl.DateTimeFormat(n, {
    month: "long",
    year: "numeric"
  }).format(t) }),
  /* @__PURE__ */ r(
    "button",
    {
      onClick: l,
      disabled: i,
      type: "button",
      className: o(
        "group rounded-full outline-hidden ",
        i && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ r(s, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  )
] });
export {
  y as DatePickerHeader
};
